import { render, staticRenderFns } from "./urkunde_a3.vue?vue&type=template&id=2d78b376&scoped=true"
import script from "./urkunde_a3.vue?vue&type=script&lang=js"
export * from "./urkunde_a3.vue?vue&type=script&lang=js"
import style0 from "./urkunde_a3.vue?vue&type=style&index=0&id=2d78b376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78b376",
  null
  
)

export default component.exports